import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { PatientAssociateModal } from './PatientAssociateModal';

type PatientAssociateModalOpenerChildrenRenderProps = {
   openModal: VoidFunction;
};
type PatientAssociateModalOpenerProps = {
   readonly children: (renderProps: PatientAssociateModalOpenerChildrenRenderProps) => JSX.Element;
   readonly unconfirmedPatient: Omit<PatientSimple, 'medicalDocumentationCreated'>;
};

export const PatientAssociateModalOpener = (props: PatientAssociateModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <PatientAssociateModal onClose={closeModal} unconfirmedPatient={props.unconfirmedPatient} />
         ) : null}
      </>
   );
};
